module.exports = __webpack_public_path__ + "img/lv4.e8e48aff.png";